import Select from "react-select";
import { Button } from "reactstrap";
import { customStyles } from "../../../utils/constant";

const ProductAdvanceFilter = ({
  show,
  filters,
  setFilters,
  categoryOptions,
  qualityOptions,
  traceabilityOptions,
  packSizeOptions,
  onCategoryChange,
  onSearch,
  onClear,
}) => {
  return (
    <>
      {show && (
        <div className="card mt-3 mb-5">
          <div className="card-body">
            <div className="row">
              <div className={filters.categoryId ? "col-md-3" : "col-md-3 "}>
                <label>Category</label>
                <Select
                  styles={customStyles}
                  isClearable
                  options={categoryOptions}
                  value={
                    filters.categoryId
                      ? categoryOptions.find(
                          (x) => x.value === filters.categoryId,
                        )
                      : null
                  }
                  onChange={(selected) => {
                    const value = selected?.value || "";

                    setFilters({
                      ...filters,
                      categoryId: value,
                      qualityId: "",
                      traceabilityId: "",
                      packSizeId: "",
                    });

                    onCategoryChange(value);
                  }}
                />
              </div>

              {filters.categoryId && (
                <>
                  <div className="col-md-3">
                    <label>Quality</label>
                    <Select
                      styles={customStyles}
                      isClearable
                      options={qualityOptions}
                      value={qualityOptions.find(
                        (x) => x.value === filters.qualityId,
                      )}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          qualityId: e?.value || "",
                        })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Source</label>
                    <Select
                      styles={customStyles}
                      isClearable
                      options={traceabilityOptions}
                      value={traceabilityOptions.find(
                        (x) => x.value === filters.traceabilityId,
                      )}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          traceabilityId: e?.value || "",
                        })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <label>Pack Size</label>
                    <Select
                      styles={customStyles}
                      isClearable
                      options={packSizeOptions}
                      value={packSizeOptions.find(
                        (x) => x.value === filters.packSizeId,
                      )}
                      onChange={(e) =>
                        setFilters({
                          ...filters,
                          packSizeId: e?.value || "",
                        })
                      }
                    />
                  </div>
                </>
              )}
              <div
                className="text-center gap-5"
                style={{ marginTop: "25px", marginLeft: "15px" }}
              >
                <Button color="primary" onClick={onSearch}>
                  Search
                </Button>

                <Button color="danger" className="ms-2 ml-2" onClick={onClear}>
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductAdvanceFilter;
